import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../context/AppContext'
import { ReactComponent as Arrow } from '../../images/uparrow.svg'
import { calculatePrice, maxSeats } from './flexprice'

const DragIndicator = ({startColumn, dragOffset, bottomDrag, info}) => {

  const [isBottom, setBottom] = useState(false)
  const [newPrice, setNewPrice] = useState('Test')
  useEffect(() => {setBottom(bottomDrag)}, [bottomDrag])
  const {preBookedSeats, tripDetails} = useContext(AppContext)

  //const dragOffset = 4
  const topRow = isBottom ? info.startRow : (info.startRow + dragOffset)
  const botRow = info.startRow + info.height + dragOffset
  const height = isBottom ? (info.height + dragOffset) : (info.height - dragOffset)
  
  const indicatorRow = `${topRow} / span ${height}`

  useEffect(() => {

    const filteredSeats = preBookedSeats
      .map(s => maxSeats-s-info.width)
      .filter((_,i) => i >= topRow-1 && i < (topRow + height-1))
      .filter(s => s >= 0)

    const {priceFrom} = calculatePrice(height, Math.min(...filteredSeats),Math.max(...filteredSeats))
    setNewPrice(priceFrom-tripDetails.priceFrom)
    
    console.log(topRow, height, priceFrom)
  }, [topRow, height, isBottom])

  return (
    <>
    <div className='booking ' style={{
      gridColumn: `${startColumn} / span ${info.width}`,
      gridRow: indicatorRow,
    }} >
      {[...Array(info.width)].map((_, i) => (
        <div className='seat drag-indicator'>
        </div>
      ))}
      <div className='drag-target'>
        <Arrow />
      </div>
      <div className='drag-target bottom'>
        <Arrow />
      </div>
      <div className={'price-change' + (isBottom ? ' bottom' : '') + (newPrice>0 ? ' increase' : ' decrease')}>
        {newPrice}
      </div>
    </div>
    <div className={'drag-line' + (isBottom ? ' bottom' : '')} style={{gridRow: isBottom ? botRow : topRow}}></div>
    </>
  )
}

export default DragIndicator
